<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<nav-bar>
	<div class="top-right-menu">
		<!-- Profile Menu -->
		<dropdown-menu #parent>
			<div
				dropdown-label
				class="nav-bar-menu-item account-name-only"
				[ngClass]="{ 'profile-menu-expanded': parent.opened$ | async }"
			>
				<div class="nav-bar-account-name" automationId="dashboardAccountName">
					<span class="nav-bar-account-name-wrapper">{{ (appState.user | async)?.parsedName }}</span>
					<i *ngIf="!(parent.opened$ | async)" class="material-icons notranslate">keyboard_arrow_down</i>
					<i *ngIf="parent.opened$ | async" class="material-icons notranslate">keyboard_arrow_up</i>
				</div>
			</div>

			<div dropdown-content class="nav-bar-dropdown-menu no-print profile-menu">
				<div (click)="goToProfile()" class="nav-bar-dropdown-menu-item" automationId="dashboardSettings">
					<i class="material-icons">account_circle</i>Account Settings
				</div>
				<div
					*ngIf="isOrgAdmin$ | async"
					(click)="openAPISettings()"
					class="nav-bar-dropdown-menu-item"
					automationId="dashboardApiSettings"
				>
					<i class="material-icons">code</i>{{ appStrings.API_SETTINGS }}
				</div>
				<div (click)="goToMobile()" class="nav-bar-dropdown-menu-item" automationId="dashboardMobilesite">
					<i class="material-icons">smartphone</i>Mobile Site
				</div>
				<div (click)="logout()" class="nav-bar-dropdown-menu-item" automationId="dashboardLogout">
					<i class="material-icons">exit_to_app</i>Log Out
				</div>
			</div>
		</dropdown-menu>

		<!-- Support Menu -->
		<support-menu></support-menu>

		<!-- Rally Point Menu -->
		<dropdown-menu #rallyParent>
			<div
				dropdown-label
				class="nav-bar-menu-item"
				[ngClass]="{ 'nav-bar-menu-item-expanded': rallyParent.opened$ | async }"
			>
				Rally Point
				<span class="nav-bar-menu-dropdown-icon">
					<i *ngIf="!(rallyParent.opened$ | async)" class="material-icons notranslate">keyboard_arrow_down</i>
					<i *ngIf="rallyParent.opened$ | async" class="material-icons notranslate">keyboard_arrow_up</i>
				</span>
			</div>

			<div dropdown-content class="nav-bar-dropdown-menu rally-point-menu-content">
				<span class="nav-bar-dropdown-menu-item">
					<access-code-quick-join [userId]="(appState.user | async)?.$id"></access-code-quick-join>
				</span>
			</div>
		</dropdown-menu>
	</div>
</nav-bar>
